import '../../App.css';
import React, { useContext, useState, useEffect } from "react";
import { ApiContext } from "../../context/ApiContext";
import { Form, Row, Col, Tabs, Tab, InputGroup } from 'react-bootstrap';
import { FaTimes } from 'react-icons/fa';
import { StyleContext } from '../../context/StyleContext';
import { ServicoContext } from '../../context/ServicoContext';
import InputMask from 'react-input-mask';

function ModalEditarFornecedor({ currentPage }) {
    const { EditarFornecedor, EdicaoFornecedor, setEdicaoFornecedor, setModalEditarFornecedor, setError } = useContext(ServicoContext)
    const { Permissao } = useContext(ApiContext)
    const { btnVer, btnCriar } = useContext(StyleContext)
    const [tipoDocumento, setTipoDocumento] = useState(0)

    const editar = (e) => {
        if (e) e.preventDefault();
        if (!EdicaoFornecedor.fantasia) {
            setError("Fantasia não informada");
            setTimeout(() => {
                setError("");
            }, 3000);
            return;
        } else if (!EdicaoFornecedor.razaoSocial) {
            setError("Razão Social não informada");
            setTimeout(() => {
                setError("");
            }, 3000);
            return;
        } else if (!EdicaoFornecedor.documento) {
            setError("Documento não informado");
            setTimeout(() => {
                setError("");
            }, 3000);
            return;
        }
        EditarFornecedor(currentPage)
            .then(() => {
                setModalEditarFornecedor(false)
            })
            .catch((error) => {
                console.log(error)
            })
    }

    const handleChange = (event) => {
        setEdicaoFornecedor({ ...EdicaoFornecedor, [event.target.name]: event.target.value })
    }

    useEffect(() => {
        if (EdicaoFornecedor?.documento) {
            const doc = EdicaoFornecedor.documento.replace(/\D/g, "");
            if (doc.length === 11) {
                setTipoDocumento(1);
            } else if (doc.length === 14) {
                setTipoDocumento(2);
            } else {
                setTipoDocumento(0);
            }
        }
    }, []);


    return (
        <div className="modal-novo">
            <div className="modal-novo-interno">
                <div className="header-modal">
                    <h1 className="h1-modal">Editar fornecedor</h1>
                    <div className="btn-close-modal" onClick={() => setModalEditarFornecedor(false)}>
                        <FaTimes />
                    </div>
                </div>
                <div>
                    <div className="modal-content">
                        <Tabs fill className='mt-3 mb-3'>
                            <Tab eventKey="info" title={<span>Informações gerais</span>}>
                                <Row>
                                    <Col xs={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Razão social</Form.Label>
                                            <Form.Control maxLength={255} defaultValue={EdicaoFornecedor?.razaoSocial} onChange={handleChange} name="razaoSocial" />
                                        </Form.Group>
                                    </Col>
                                    <Col xs={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Nome fantasia</Form.Label>
                                            <Form.Control maxLength={255} defaultValue={EdicaoFornecedor?.fantasia} onChange={handleChange} name="fantasia" />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={3}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Tipo do Documento</Form.Label>
                                            <Form.Select
                                                aria-label="Default select example"
                                                value={tipoDocumento}
                                                onChange={(e) => {
                                                    const value = Number(e.target.value);
                                                    setTipoDocumento(value);
                                                    setEdicaoFornecedor(prev => ({ ...prev, documento: '' }));
                                                }}
                                                name="tipoDocumento"
                                            >
                                                <option value={0}>Selecione</option>
                                                <option value={1}>CPF</option>
                                                <option value={2}>CNPJ</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col xs={3}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Documento identificação</Form.Label>
                                            <InputGroup>
                                                <Form.Control
                                                    as={InputMask}
                                                    mask={tipoDocumento == 1 ? '999.999.999-99' : '99.999.999/9999-99'}
                                                    maxLength={255} onChange={handleChange}
                                                    value={EdicaoFornecedor?.documento} name="documento"
                                                />
                                            </InputGroup>
                                        </Form.Group>
                                    </Col>
                                    <Col xs={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Telefone</Form.Label>
                                            <Form.Control as={InputMask} mask="(99) 99999-9999" maxLength={255} defaultValue={EdicaoFornecedor?.telefone} onChange={handleChange} name="telefone" />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>E-mail</Form.Label>
                                            <Form.Control type='email' maxLength={255} defaultValue={EdicaoFornecedor?.email} onChange={handleChange} name="email" />
                                        </Form.Group>
                                    </Col>
                                    <Col xs={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Site</Form.Label>
                                            <Form.Control maxLength={255} defaultValue={EdicaoFornecedor?.site} onChange={handleChange} name="site" />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Tab>
                            <Tab eventKey="endereco" title={<span>Endereço</span>}>
                                <Row>
                                    <Col xs={3}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>CEP</Form.Label>
                                            <Form.Control as={InputMask} mask="99999-999" maxLength={255} defaultValue={EdicaoFornecedor?.cep} onChange={handleChange} name="cep" />
                                        </Form.Group>
                                    </Col>
                                    <Col xs={3}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>UF</Form.Label>
                                            <Form.Control as={InputMask} mask="aa" maxLength={255} defaultValue={EdicaoFornecedor?.uf} onChange={handleChange} name="uf" />
                                        </Form.Group>
                                    </Col>
                                    <Col xs={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Cidade</Form.Label>
                                            <Form.Control maxLength={255} defaultValue={EdicaoFornecedor?.cidade} onChange={handleChange} name="cidade" />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Endereço</Form.Label>
                                            <Form.Control maxLength={255} defaultValue={EdicaoFornecedor?.endereco} onChange={handleChange} name="endereco" />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={3}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Número</Form.Label>
                                            <Form.Control type='number' maxLength={255} defaultValue={EdicaoFornecedor?.numero} onChange={handleChange} name="numero" />
                                        </Form.Group>
                                    </Col>
                                    <Col xs={3}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Bairro</Form.Label>
                                            <Form.Control maxLength={255} defaultValue={EdicaoFornecedor?.bairro} onChange={handleChange} name="bairro" />
                                        </Form.Group>
                                    </Col>
                                    <Col xs={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Complemento</Form.Label>
                                            <Form.Control maxLength={255} defaultValue={EdicaoFornecedor?.complemento} onChange={handleChange} name="complemento" />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Tab>
                        </Tabs>
                    </div>
                    <div className="footer-modal-criar-demanda">
                        <button type="button" className="btn-dash btn-ver" style={btnVer} onClick={() => setModalEditarFornecedor(false)}>Cancelar</button>
                        {(!!Permissao.find(item => item.menu.descricao === "CADASTROS" && item.edicao === true)) &&
                            <button type='button' className="btn-dash btn-criar" style={btnCriar} onClick={(e) => {
                                e.preventDefault();
                                editar();
                            }}>Salvar</button>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ModalEditarFornecedor